<template>
    <span v-click-outside="hide" class="combo">
        <span class="reason" @click="showReasons=(!showReasons && canEdit)"> {{ line.reason ? $t(line.reason.name || line.reason.description) : '' }}</span>
        <span id="status-box" v-if="showReasons && _reasons.length > 0">
            <span v-for="(rs, index) in _reasons"  :key="index">
                <span class="combo-opt" :title="rs.description" @click="setReason(rs)">
                    {{ $t(rs.name) }}
                </span>
            </span>
        </span>
    </span>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'reason-combo',
  components: {},
  props: {reasons: {default: () => { return [] }}, line: {}, type: ''},
  mounted () {
    this.checkPermissions(['editReason']).then((response) => { this.canEdit = response })
    this.checkSingleReason()
  },
  watch: {
    _reasons: function (val) {
      this.checkSingleReason()
    }
  },
  data () {
    return {
      showReasons: false,
      canEdit: false
    }
  },
  computed: {
    _reasons: {
      get: function () {
        var map = new Map(this.reasons.map(x => [Object.keys(x)[0], x[Object.keys(x)[0]]])) // turns [{status1: []}, {status2: []}] in {status1: [], status2: []}
        return map.get('status' + this.line.status.id) || []
      }
    }
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions'
    }),
    hide () {
      this.showReasons = false
    },
    setReason (rs) {
      this.$emit('reasonChanged', { reason: rs })
      this.hide()
    },
    checkSingleReason () {
      if (this._reasons.length === 1) {
        this.line.reason = this._reasons[0]
      }
    }
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.reason {
  transition: .3s;
}
.combo-opt {
  margin: .5em auto;
  text-transform: uppercase;
}
#status-box {
  transition: .3s;
  position: absolute;
  top: 3em;
  left: 0;
  background: white;
  width: 100%;
  border: 1px solid #E1E1E1;
  box-sizing: border-box;
  z-index: 999;
  padding: .3em;
}
</style>



// WEBPACK FOOTER //
// src/components/ReasonCombo.vue